// core/redux/productFilters.slice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    searchText: "",
    selectedGroup: "",
    selectedModel: "",
    selectedUnit: "",
    activeTab: "finished",
    paginationByTab: {
        finished: { current: 1, pageSize: 20 },
        semi: { current: 1, pageSize: 20 },
        raw: { current: 1, pageSize: 20 },
        bureautique: { current: 1, pageSize: 20 },
    },
};

const productFiltersSlice = createSlice({
    name: "productFilters",
    initialState,
    reducers: {
        setSearchText: (state, action) => {
            state.searchText = action.payload;
        },
        setSelectedGroup: (state, action) => {
            state.selectedGroup = action.payload;
        },
        setSelectedModel: (state, action) => {
            state.selectedModel = action.payload;
        },
        setSelectedUnit: (state, action) => {
            state.selectedUnit = action.payload;
        },
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
        },
        setPaginationByTab: (state, action) => {
            const { tab, current, pageSize } = action.payload;
            state.paginationByTab[tab] = { current, pageSize };
        },
        resetProductFilters: () => initialState,
    },
});

export const {
    setSearchText,
    setSelectedGroup,
    setSelectedModel,
    setSelectedUnit,
    setActiveTab,
    setPaginationByTab,
    resetProductFilters,
} = productFiltersSlice.actions;

export default productFiltersSlice.reducer;